import React from "react";
import { useTranslation } from "react-i18next";
import "../../i18next";
import atm_net_school from "../../assets/images/School/atm_net_school.jpg";
import school_image from "../../assets/images/School/school1.png";
import imgCajero2 from "../../assets/images/School/imgCajero2.JPG";
import service from "../../assets/images/School/servicio.JPG";
import laboratory from "../../assets/images/School/laboratorio.jpg";
import monitoring from "../../assets/images/School/monitoreo.png";
import analisys from "../../assets/images/School/analisis.JPG";
import capacity from "../../assets/images/School/capacitacion.JPG";
import tranning from "../../assets/images/School/entrenamiento.jpg";
import categories from "../../assets/images/School/Categories.png";
import AnimatedElement from "../AnimatedElement";
import ContactForm from "../Contactenos/ContactForm";

function SeccionSchool() {
  const { t } = useTranslation();

  return (
    <>
      <main className="bg-white font-sans">
        {/* Encabezado principal */}
        <header className="relative mt-16 md:mt-32">
          <div className="relative w-full  mx-auto">
            {/* Título superpuesto */}
            <h1
              className="absolute top-4 left-4 md:top-8 md:left-8 text-orangeAtm font-bold text-4xl md:text-8xl z-20 p-0"
              style={{ fontFamily: "Helvetica" }}
            >
              {t("school.title")}
            </h1>

            {/* Imagen */}
            <AnimatedElement
              fromDirection="bottom"
              className="mt-[-10px] sm:mt-[-20px] md:mt-[-50px] lg:mt-[-125px]"
            >
              <img
                className="object-contain w-full h-auto"
                src={atm_net_school}
                alt="Nosotros"
              />
            </AnimatedElement>
          </div>
        </header>

        {/* Sección de introducción */}
        <section className="w-11/12 mx-auto my-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h2 className="text-orangeAtm font-bold text-3xl md:text-6xl mb-4">
              {t("school.subtitle")}
            </h2>
            <h3 className="text-orangeAtm font-bold text-xl md:text-4xl mb-4">
              {t("school.subtitle2")}
            </h3>
          </div>
          <div>
            <p className="text-customDarkBlue text-sm md:text-lg">
              {t("school.text1")}
            </p>
          </div>
        </section>

        {/* Sección de descripción */}
        <section className="w-11/12 mx-auto my-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-darkBlueText text-2xl md:text-5xl font-bold mb-4">
              {t("school.subtitle3")}
            </h3>
            <p className="text-customDarkBlue text-sm md:text-xl">
              {t("school.text2")}
            </p>
          </div>
          <div className="hidden md:block">
            <img src={school_image} alt="Product" className="w-full h-auto" />
          </div>
        </section>

        {/* Sección de categorías */}
        <section className="bg-darkBlueText text-white py-16">
          <div className="w-11/12 mx-auto text-center">
            <h2 className="text-orangeAtm text-2xl md:text-6xl font-bold mb-4">
              {t("school.title2")}
            </h2>
            <p className="text-xs md:text-lg mb-8">{t("school.text3")}</p>
            {/* <img src={categories} alt="categories" className="mx-auto mb-12" /> */}
          </div>
          <div className="w-11/12 mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              service,
              laboratory,
              monitoring,
              analisys,
              capacity,
              tranning,
            ].map((img, index) => (
              <article key={index} className="text-center">
                <img
                  src={img}
                  alt={`school image ${index + 1}`}
                  className="mb-4 rounded-2xl h-96 w-full object-cover"
                />
                {/* <button className="bg-gray-500 p-1 mb-2">
                  {t("school.category")}
                </button> */}
                <h3 className="text-lg md:text-[28px] font-bold mb-2">
                  {t(`school.titleImg${index + 1}`)}
                </h3>
                <p className="text-xs md:text-lg">
                  {t(`school.textImg${index + 1}`) ?? ""}
                </p>
              </article>
            ))}
          </div>
        </section>

        {/* Sección de formulario */}
        <section className="w-11/12 mx-auto py-16 grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-orangeAtm text-3xl md:text-6xl font-bold mb-6">
              {t("school.subtitle4")}
            </h2>
            <p className="text-customDarkBlue text-sm md:text-xl mb-8">
              {t("school.text4")}
            </p>
            <ContactForm />
          </div>

          <aside className="hidden md:block">
            <img
              src={imgCajero2}
              alt="ATM representative"
              className="rounded-xl w-full h-[900px] object-cover"
            />
          </aside>
        </section>
      </main>
    </>
  );
}

export default SeccionSchool;
